import { createFileRoute } from '@tanstack/react-router'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { REGISTER_WRITE_ROLES } from '@/features/medication-register/access'
import { CorrectEntryPage } from '@/features/medication-register/correct-entry-page'

/** Correcting a line (X7) is a manager write. */
export const Route = createFileRoute(
  '/_authenticated/_organization/compliance/drugs-register/$accountId/entries/$entryId/correct'
)({
  beforeLoad: async () => {
    await requireRoles([...REGISTER_WRITE_ROLES])
    await requireActiveSubscription()
  },
  component: CorrectEntryPage,
})
